<template>
    <div class="rounded-md bg-green-50 p-4" :class="{'bg-green-50': $page.props.flash.success, 'bg-red-50': $page.props.flash.error}" v-if="$page.props.flash.success || $page.props.flash.error">
        <div class="flex">
            <div class="flex-shrink-0">
                <CheckCircleIcon v-if="$page.props.flash.success" class="h-5 w-5 text-green-400" aria-hidden="true" />
                <XCircleIcon v-if="$page.props.flash.error" class="h-5 w-5 text-red-400" aria-hidden="true" />
            </div>
            <div class="ml-3">
                <p class="text-sm flex" :class="{'text-green-800': $page.props.flash.success, 'text-red-800': $page.props.flash.error}">
                    <span v-if="$page.props.flash.success" v-html="$page.props.flash.success"></span>
                    <span v-if="$page.props.flash.error" v-html="$page.props.flash.error"></span>
                    <Link v-if="$page.props.flash.action" :href="$page.props.flash.action.url" class="ml-1 underline" v-html="$page.props.flash.action.title"/>
                </p>
            </div>
            <div class="ml-auto pl-3">
                <div class="-mx-1.5 -my-1.5">
                    <button type="button"
                            :class="{
                                'bg-green-50 text-green-500 hover:bg-green-100 focus:ring-offset-green-50 focus:ring-green-600': $page.props.flash.success,
                                'bg-red-50 text-red-500 hover:bg-red-100 focus:ring-offset-red-50 focus:ring-red-600': $page.props.flash.error,
                            }
                        " class="inline-flex  rounded-md p-1.5  focus:outline-none focus:ring-2 focus:ring-offset-2 ">
                        <span class="sr-only">Dismiss</span>
                        <XIcon class="h-5 w-5" aria-hidden="true" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { CheckCircleIcon, XIcon, XCircleIcon } from '@heroicons/vue/solid'
import {Link} from "@inertiajs/vue3";

export default {
    components: {
        CheckCircleIcon,
        XIcon,
        XCircleIcon,
        Link
    },
}
</script>
